import Cookies from 'js-cookie';

// 前端认证
const TokenKey = 'SESSION';
// 后端认证
const serverTokenKey = 'ticket';

const SassUserName = 'SASSUSERNAME';
const SassUserPwd = 'SASSUSERPWD';

export function getToken() {
    return Cookies.get(TokenKey);
}

export function setToken(token) {
    return Cookies.set(TokenKey, token);
}

export function removeToken() {
    Cookies.remove(serverTokenKey);
    return Cookies.remove(TokenKey);
}

export function getSassUserName() {
    return Cookies.get(SassUserName);
}

export function setSassUserName(value) {
    return Cookies.set(SassUserName, value);
}

export function getSassUserPwd() {
    return Cookies.get(SassUserPwd);
}

export function setSassUserPwd(value) {
    return Cookies.set(SassUserPwd, value);
}

export function removeSassUserName() {
    return Cookies.remove(SassUserName);
}
export function removeSassUserPwd() {
    return Cookies.remove(SassUserPwd);
}
